import { Flex, Stack, Text } from '@mantine/core';
import { ReactNode } from 'react';

import classes from './Text.module.css';

interface TitleCardProps {
  title: string;
  pre?: ReactNode;
  below?: ReactNode;
}

export function TitleCard({ title, pre, below }: TitleCardProps) {
  const heading = (
    <>
      {pre}
      <Text fw="500">{title}</Text>
    </>
  );

  if (below == null) {
    return (
      <Flex
        align="center"
        gap="10px"
        className={classes.titleCardContainer}
        p="sm"
      >
        {heading}
      </Flex>
    );
  }

  return (
    <Stack
      gap="6px"
      align="flex-start"
      className={classes.titleCardContainer}
      p="sm"
    >
      <Flex
        align="center"
        gap="10px"
      >
        {heading}
      </Flex>
      {below}
    </Stack>
  );
}
